'use client';

export { default } from './GlobalStyles';
export * from './GlobalStyles';


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/GlobalStyles/index.js
// module id = 1569
// module chunks = 22